import type { AnyAction } from 'redux';

import { STORE, CLEAR, UPDATE_ORGANIZATION, UPDATE_PROPERTY } from './constants';
import type User from './model';

export type UserState = User | null;

const initialState: UserState = null;

export default (state: UserState = initialState, action: AnyAction): UserState => {
  switch (action.type) {
    case STORE: {
      let { user } = action;
      const { properties } = action;
      if (properties.length > 0) {
        user = state;
        properties.forEach((property) => {
          user = user.set(property, action.user[property]);
        });
      }
      return user;
    }

    case UPDATE_PROPERTY:
      return state?.setIn(action.property, action.value);

    case UPDATE_ORGANIZATION:
      return state?.set('organization', action.organization);

    case CLEAR:
      return initialState;

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
